import { useCallback, useEffect, useMemo, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Header as HeaderComponent } from 'sfy-react'
import ChangeLanguage from '../ChangeLanguage'
import { ReactComponent as HomeIcon } from '../../../assets/images/home.svg'
import { ReactComponent as PlansIcon } from '../../../assets/images/plans.svg'
import { ReactComponent as StoreIcon } from '../../../assets/images/shopping-bag.svg'
import { ReactComponent as DevicesIcon } from '../../../assets/images/devices.svg'
import { ReactComponent as ProfileIcon } from '../../../assets/images/profile.svg'
import { ReactComponent as NotificationIcon } from '../../../assets/images/notification.svg'
import styles from '../ChangeLanguage/ChangeLanguage.module.scss'
import MobileHeader from '../MobileHeader/MobileHeader'
import { capitalize } from '../../../utils/functions'
import { postRequestAsync } from '../../genericAPIs'

const routes = {
  home: {
    route: '/home',
    icon: <HomeIcon className='svg-stroke' />,
    showOnHeader: true,
  },
  'my devices': {
    route: '/product',
    icon: <DevicesIcon />,
    showOnHeader: true,
  },
  'my plans': {
    route: '/plans',
    icon: <PlansIcon />,
    showOnHeader: true,
  },
  store: {
    route: '/store',
    icon: <StoreIcon className='svg-stroke' />,
    showOnHeader: true,
  },
  notifications: {
    route: '/notifications',
    icon: <NotificationIcon />,
    showOnHeader: true,
  },
  profile: {
    route: '/profile',
    icon: <ProfileIcon />,
    showOnHeader: true,
  },
}

const Header = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const transactionalData = useSelector((state) => state.common.transactionalData)
  const isTransactionalFlow = transactionalData?.isTransactionalFlow
  const consumerDetails = useSelector((state) => state.user.consumerDetails)
  const appConfigDetails = useSelector((state) => state.common.appConfigDetails)
  const userDetails = useSelector((state) => state.user.userDetails)
  const notifications = useSelector((state) => state.common.notifications)
  const showChangeLanguageOption = useSelector((state) => state.common.showChangeLanguageOption)

  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth < 992)
  const [navItems, setNavItems] = useState([])
  const [loginButtonClass, setLoginButtonClass] = useState('button-ghost')

  useEffect(() => {
    const onScroll = () => {
      if (!consumerDetails.accessToken?.ID) {
        if (window.pageYOffset < 10) {
          setLoginButtonClass('button-ghost')
        } else if (window.pageYOffset > 20) {
          setLoginButtonClass('button-primary')
        }
      }
    }

    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [consumerDetails.accessToken?.ID])

  const unReadNotification = useMemo(() => {
    let count = 0
    notifications.forEach((notification) => {
      !notification.isRead && count++
    })
    return count
  }, [notifications])

  const onNameClick = useCallback(async () => {
    try {
      const response = await postRequestAsync('/coreapi/api/Consumer/resetConsumerProduct', {
        consumerID: +sessionStorage.getItem('consumerID'),
      })
      if (response) {
        await postRequestAsync('/clean_chat', {
          consumerID: +sessionStorage.getItem('consumerID'),
        }, 'chatbot')
      }
    } catch (e) {
      console.log(e)
    }
  }, [])

  useEffect(() => {
    const navbarHeaders = ['Profile'].filter((item) => routes[item.toLowerCase()]?.showOnHeader)

    const changeLanguageTab = appConfigDetails.showChangeLanguageOption &&
      showChangeLanguageOption && { component: <ChangeLanguage classContainer={`width-100 ${styles['header-language-container']}`} /> }
    let navItems = []
    if (consumerDetails.accessToken?.ID) {
      navItems = navbarHeaders.map((item) => ({
        ...(item === 'Notifications' && unReadNotification > 0 && { badgeContent: unReadNotification }),
        title: capitalize(item === 'Profile' ? userDetails.name : item),
        ...routes[item.toLowerCase()],
        onClick: onNameClick,
        isActive: routes[item.toLowerCase()].route?.includes(location.pathname),
      }))
    } else {
      navItems = [
        {
          title: 'Login',
          onClick: () => {
            navigate('/login')
          },
          isActive: false,
          buttonElement: true,
          classes: `${loginButtonClass} mb20 mt20`,
        },
      ]
    }

    if (changeLanguageTab) {
      navItems.push(changeLanguageTab)
    }
    setNavItems(navItems)
  }, [
    appConfigDetails,
    showChangeLanguageOption,
    consumerDetails,
    location,
    navigate,
    userDetails,
    loginButtonClass,
    unReadNotification,
    onNameClick,
  ])

  useEffect(() => {
    const handleOnResize = () => {
      setIsMobileScreen(window.innerWidth < 992)
    }
    window.addEventListener('resize', handleOnResize)
    return () => {
      window.removeEventListener('resize', handleOnResize)
    }
  }, [])

  return (
    <>
      {!location.pathname.includes('/login') &&
        (!isMobileScreen ? (
          <HeaderComponent
            className={{
              header: `flex-grow ${isTransactionalFlow ? 'bg-gray' : ''}`,
              nav: `align-self-center`,
              navItem: `${styles['header-items-align']}`,
              navLink: `mb0 pb0 text-capitalize`,
            }}
            position='sticky-top'
            iconType='svg'
            brand={
              <img
                className='header-logo'
                src={`/${window.appName}/images/logo.png`}
                onClick={() => {
                  navigate('/')
                }}
                alt='logo'
              />
            }
            navItems={!isTransactionalFlow ? navItems : []}
          />
        ) : (
          <MobileHeader />
        ))}
    </>
  )
}

export default Header
